export default {
  methods: {
    setHost(path) {
      return process.env.VUE_APP_HOST + '/' + path
    },
  },
};
